export const SPRITE_SYMBOL_IDS = {
    INFO: 'sprite-info',
    FANDUEL_SHIELD: 'sprite-fanduel-shield'
} as const;
